import { $$ } from "@utils/select";
import Flickity from "flickity";
import "flickity-as-nav-for";
import { listen } from "@utils/bph";

const FIX = "flickity-flex";
const FADE = "flickity-fade";
const NAV = "flickity-nav";

export default () => {
  let slider = null;
  let nav = null;

  return {
    currentIdx: 0,

    init() {
      this.$$slides = $$('[x-ref="slide"]', this.$el);
      this.$refs.slider.classList.add(FIX);
      this.$refs.nav.classList.add(FIX, NAV);
      this.$refs.slider.classList.add(FADE);

      if (this.$$slides.length < 2) return;

      slider = new Flickity(this.$refs.slider, {
        prevNextButtons: false,
        pageDots: false,
        wrapAround: true,
      });

      slider.on("select", async () => {
        this.currentIdx = slider.selectedIndex;
      });

      if (this.$refs.nav) {
        listen("md", ({ matches }) => this.initNav(matches));
        this.$refs.nav.classList.add(FIX);
      }
    },

    selectIndex(idx) {
      slider.select(idx);
    },

    initNav(matches) {
      if (matches) {
        if (nav) nav.destroy();
      } else {
        nav = new Flickity(this.$refs.nav, {
          prevNextButtons: false,
          pageDots: false,
          asNavFor: this.$refs.slider,
        });

        nav.on("change", (idx) => this.selectIndex(idx));
      }
    },
  };
};
